import { render } from "./MiinventoryCreate.vue?vue&type=template&id=0b09f3aa&scoped=true"
import script from "./MiinventoryCreate.vue?vue&type=script&lang=js"
export * from "./MiinventoryCreate.vue?vue&type=script&lang=js"

import "./MiinventoryCreate.vue?vue&type=style&index=0&id=0b09f3aa&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b09f3aa"]])

export default __exports__